export { ClampedText } from './ClampedText'
